// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folders_dropdown_choose_container-module__container--2bfdb{max-height:350px;overflow-y:auto;-webkit-overflow-scrolling:touch;text-align:left}@media screen and (max-width: 48em){.folders_dropdown_choose_container-module__container--2bfdb{max-height:190px}}\n", ""]);
// Exports
exports.locals = {
	"container": "folders_dropdown_choose_container-module__container--2bfdb"
};
module.exports = exports;
